// extracted by css-extract-rspack-plugin
export default {"tickPath":"_tickPath_csjVD","tickVisible":"_tickVisible_wejl1","tickHidden":"_tickHidden_oXghq"};